import createReactComponent from '../createReactComponent';
export default createReactComponent('number-9', 'IconNumber9', [
  ['path', { d: 'M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0', key: 'svg-0' }],
  ['path', { d: 'M8 16a4 4 0 1 0 8 0v-8', key: 'svg-1' }],
]);
